import evcsImg from "../../../assets/images/service/evcs-deployment.png";
import {
  Settings,
  Zap,
  FileCheck,
  ShieldCheck,
  Clock,
  HardHat,
  TrendingUp,
  Maximize,
  UserCheck,
  BatteryCharging,
  Layout
} from "lucide-react";
import ServiceSidebar from "../sidebar";

export default function EVCSDeployment() {
  return (
    <>
      <section className="service-detail py-10">
        <div className="container">
          <div className="service-detail-inner">
            {/* Feature Section */}
            <div className="service-feature mb-8">
              <div className="row align-items-center gy-5">
                {/* Content */}
                <div className="col-lg-6 px-8 feature-content">
                  <h2 className="fw-bold mb-2">
                    Turnkey <span className="green">EVCS Deployment</span> For Sustainable Mobility
                  </h2>
                  <p className="mb-4">
                    Denial Enterprise offers comprehensive Turnkey EV Charging Station solutions, 
                    covering everything from site feasibility and electrical infrastructure 
                    to charger installation and software integration.
                  </p>

                  <div className="feature-points">
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>End-to-end site survey, design & installation</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>AC & DC Fast Charger deployment (3.3kW to 240kW+)</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>CMS integration & cloud-based monitoring</span>
                    </div>
                  </div>
                </div>
                {/* Image */}
                <div className="col-lg-6">
                  <div className="feature-image position-relative">
                    <img
                      src={evcsImg}
                      alt="Turnkey EVCS Deployment"
                      className="w-100 rounded2 shadow"
                    />
                    <div className="image-badge">
                      <i className="fa fa-charging-station"></i> Ready-to-Charge Solutions
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Info */}
            <div className="service-info">
              <div className="row mt-6 gx-lg-5 gy-5">
                <div className="col-lg-4">
                  <ServiceSidebar />
                </div>
                {/* Left Content */}
                <div className="col-lg-8">
                  <div className="about-service mb-6">
                    <h3 className="mb-2">About the Service</h3>
                    <p className="mb-3">
                      Denial Enterprise provides a "plug-and-play" approach to EV infrastructure. We manage the complexities of power procurement, load sanctioned permissions, and civil works, allowing businesses and fleet operators to focus on their core operations while we build their charging network.
                    </p>
                    <p className="mb-3">
                      Whether it's for public charging hubs, residential societies, or industrial captive fleets, our turnkey services ensure that your EVCS is compliant with OCPP protocols and local safety regulations.
                    </p>

                    <ul className="icon-list-modern icon-list list-unstyled">
                      <li>
                        <span className="icon-wrap">
                          <Layout size={22} />
                        </span>
                        <span>Site Feasibility & Load Calculation</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Zap size={22} />
                        </span>
                        <span>HT/LT Electrical Infrastructure Setup</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <BatteryCharging size={22} />
                        </span>
                        <span>Charger Installation (AC/DC) & Commissioning</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <FileCheck size={22} />
                        </span>
                        <span>Liaison with Discoms & Statutory Approvals</span>
                      </li>
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="service-benefit">
                    <h4 className="mb-3">How You Benefit</h4>
                    <p className="mb-6">
                      By choosing a turnkey partner, you eliminate the hassle of dealing with multiple vendors. We provide a single point of contact for civil, electrical, and software requirements, ensuring a streamlined path to ROI.
                    </p>
                    <ul className="icon-list-modern benefit-list">
                      <li>
                        <span className="icon-wrap">
                          <Clock size={22} />
                        </span>
                        <span>Rapid deployment with optimized timelines</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Settings size={22} />
                        </span>
                        <span>Seamless hardware and CMS software integration</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <ShieldCheck size={22} />
                        </span>
                        <span>Safe, reliable, and compliant infrastructure</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TrendingUp size={22} />
                        </span>
                        <span>Optimized CAPEX and lower operational costs</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Maximize size={22} />
                        </span>
                        <span>Modular design for future power upgrades</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <UserCheck size={22} />
                        </span>
                        <span>24/7 technical support and maintenance</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}